<template>
  <div>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title class="hidden-xs-only">Leads Overview</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Search Box -->
      <v-flex mr-3>
        <v-text-field color="white" v-model="search" append-icon="search" label="Search Leads List" single-line hide-details></v-text-field>
      </v-flex>
      <!-- End: Search Box -->
      <v-menu offset-y class="mr-3 hidden-xs-only">
        <v-btn slot="activator" outline><v-icon left>filter_list</v-icon>Filter Users</v-btn>
        <v-list>
          <v-list-tile v-for="(lead, index) in usersWithLeads" :key="index">
            <v-list-tile-title @click="userFilter = lead">{{ lead.name }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn v-if="user.permissions.others.showAllLeads" class="mr-3 hidden-xs-only" @click="statsUser = null; showLeadStats = true; mobileView = 'detail'" flat dark outline><v-icon left>assessment</v-icon>All Leads Report</v-btn>
      <v-btn class="mr-3 hidden-xs-only" outline @click="showInactive = !showInactive; ifInactiveToggled()"><v-icon left>{{showInactive ? 'visibility_off' : 'visibility'}}</v-icon>{{showInactive ? 'Hide Inactive' : 'Show Inactive'}}</v-btn>
      <v-btn class="hidden-xs-only" @click="addNewLeadDialog = true" outline><v-icon left>add</v-icon>New Lead</v-btn>
      <!-- Mobile Only -->
      <v-menu offset-y class="mr-3 hidden-sm-and-up">
        <v-btn slot="activator" icon><v-icon>filter_list</v-icon></v-btn>
        <v-list>
          <v-list-tile v-for="(lead, index) in usersWithLeads" :key="index">
            <v-list-tile-title @click="userFilter = lead">{{ lead.name }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn v-if="user.permissions.others.showAllLeads" class="mr-3 hidden-sm-and-up" @click="statsUser = null; showLeadStats = true; mobileView = 'detail'" flat dark icon><v-icon>assessment</v-icon></v-btn>
      <v-btn class="mr-3 hidden-sm-and-up" icon @click="showInactive = !showInactive; ifInactiveToggled()"><v-icon>{{showInactive ? 'visibility_off' : 'visibility'}}</v-icon></v-btn>
      <v-btn class="hidden-sm-and-up" @click="addNewLeadDialog = true" icon><v-icon>add</v-icon></v-btn>
      <!-- End: Mobile Only -->
    </v-toolbar>
    <v-container fluid :class="onMobile ? '' : 'pageContainer'">
      <v-layout row wrap>
      <div :class="onMobile ? '' : 'scroll'" :style="onMobile ? '' : 'width: 40%; height: 100%'">
      <v-flex v-if="!filteredLeadsList || filteredLeadsList.length < 1">
        <span class="title">No Leads Found. Create a New Lead To Start.</span>
      </v-flex>
      <v-flex xs12 v-if="filteredLeadsList && filteredLeadsList.length > 0" :class="mobileLeadsView">
        <v-list three-line>
          <template v-for="(lead, index) in filteredLeadsList">
            <v-subheader class="secondary white--text" v-if="lead.header" :key="index">Leads for {{ lead.header }}
              <v-spacer></v-spacer>
              <span class="hidden-xs-only">Leads: {{lead.totalLeads}}</span>
              <v-btn @click="statsUser = lead.userId; showLeadStats = true; mobileView = 'detail'" class="ml-4" flat dark outline>Reports<v-icon right>assessment</v-icon></v-btn>
              <!-- <v-btn class="ml-4" dark icon @click="lead.expand = !lead.expand"><v-icon>{{lead.expand ? 'expand_less' : 'expand_more'}}</v-icon></v-btn> -->
            </v-subheader>
            <v-divider v-else-if="lead.divider" :key="index"></v-divider>
            <v-list-tile v-else-if="fullLeadName(lead) && fullLeadName(lead).match(new RegExp(search, 'gi'))" :key="index" @click="selectedLead = lead; getLeadNotes(lead); mobileView = 'detail'; showLeadStats = false" :style="selectedLead === lead ? 'background-color: white; border-left: 10px solid ' + statusBorders(lead.status) + ';' : 'background-color: rgba(0, 0, 0, 0.1); border-left: 10px solid ' + statusBorders(lead.status) + ';'">
              <v-list-tile-content class="pt-3 pb-3">
                <v-layout>
                <v-list-tile-title v-html="lead.opportunities.job_name ? lead.opportunities.job_name + ' (' + lead.company_name + ')' : lead.company_name ? lead.company_name : fullLeadName(lead)"></v-list-tile-title>
                </v-layout>
                <!-- <v-list-tile-sub-title v-if="lead.opportunities.description" class="caption" v-html="lead.opportunities.description"></v-list-tile-sub-title> -->
                <v-layout row wrap class="mt-2">
                  <span class="body-1">{{lead.opportunities.city + ', ' + lead.opportunities.state}}</span>
                  <span class="ml-3 body-1">{{lead.phone_1 ? formatPhoneNumber(lead.phone_1) : ''}}</span>
                  <span class="primary--text ml-3 body-1">{{lead.email ? lead.email : ''}}</span>
                </v-layout>
              </v-list-tile-content>
              <v-list-tile-action style="width: 90px" class="hidden-md-and-down">
                <v-list-tile-action-text>{{ lead.opportunities.created_date.seconds | moment('MMM Do YYYY') }}</v-list-tile-action-text>
                <v-list-tile-action-text>Min: {{lead.opportunities.budget_min ? formatCurrency(lead.opportunities.budget_min) : 0}} - Max: {{lead.opportunities.budget_max ? formatCurrency(lead.opportunities.budget_max) : 0}}</v-list-tile-action-text>
                <v-list-tile-action-text v-if="lead.source">Source: {{lead.source}}</v-list-tile-action-text>
              </v-list-tile-action>
              <v-list-tile-action class="hidden-lg-and-up"><v-icon>chevron_right</v-icon></v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
      </div>
<!-- Selected Lead Data -->
      <div :class="onMobile ? '' : 'scroll'" :style="onMobile ? '' : 'width: 60%; height: 100%'" v-if="selectedLead && !showLeadStats">
      <v-flex xs12 :class="mobileDetailView">
        <!-- Mobile Toolbar -->
        <v-toolbar @click="mobileView = 'leads'" class="hidden-md-and-up" flat height="48px" dark color="secondary">
          <v-icon>chevron_left</v-icon>
          <v-toolbar-title>Back to Leads List</v-toolbar-title>
        </v-toolbar>
        <!-- End: Mobile Toolbar -->
        <v-layout row wrap>
          <!-- <v-flex xs8> -->
            <v-menu offset-y>
              <v-btn class="ml-2" slot="activator" flat :class="statusColors(selectedLead.status)">{{selectedLead.status}}</v-btn>
              <v-list class="text-xs-center" style="background-color: rgba(255, 255, 255, 0.95)">
                <div class="pa-2 secondary title white--text"><span>Lead Status</span></div>
                <v-flex v-for="(status, index) in leadStatus" :key="index">
                  <div style="cursor: pointer" @click="statusChange(status)" class="text-xs-center font-weight-bold subheading pa-3" :class="statusColors(status)">{{ status }}</div>
                </v-flex>
              </v-list>
            </v-menu>
            <v-btn v-if="!selectedLead.opportunities.revertedToLeads" class="ml-2" @click="loadConversionWindow" outline>Send To Pre-Construction</v-btn>
            <v-btn v-if="selectedLead.opportunities.revertedToLeads" class="ml-2" @click="loadConversionWindow" outline>Restore Project</v-btn>
          <!-- </v-flex> -->
          <!-- <v-flex xs4 class="text-xs-right"> -->
            <v-spacer></v-spacer>
            <v-layout column>
              <span class="body-2">Min: {{formatCurrency(selectedLead.opportunities.budget_min)}} - Max: {{formatCurrency(selectedLead.opportunities.budget_max)}}</span>
              <span class="body-2" v-if="selectedLead.source">Source: {{selectedLead.source}}</span>
            </v-layout>
          <!-- </v-flex> -->
        </v-layout>
        <v-toolbar height="48px" flat>
          <v-toolbar-title>{{selectedLead.opportunities.job_name ? selectedLead.opportunities.job_name + ' (' + selectedLead.company_name + ')' : selectedLead.company_name ? selectedLead.company_name : fullLeadName(selectedLead)}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click ="editLeadDialog = true" outline><v-icon left>edit</v-icon>Edit</v-btn>
        </v-toolbar>
        <v-alert v-if="selectedLead.opportunities.revertedToLeads" :value="true" type="info">This lead is from a reverted project. Note that restoring the project restores all previous project details including tasks.</v-alert>
        <div class="pl-4 pt-2" color="white">
          <!-- Primary Contact Details -->
          <v-layout>
            <v-icon>phone</v-icon>
            <span class="contactText ml-3" @click="contactLinks('phone', selectedLead.phone_1)">{{formatPhoneNumber(selectedLead.phone_1)}}</span>
            <span v-if="selectedLead.phone_type_1" class="contactText ml-2">({{selectedLead.first_name + ' ' + [selectedLead.phone_type_1 ? selectedLead.phone_type_1 : '']}})</span>
            <v-icon v-if="selectedLead.phone_2" class="ml-3">phone</v-icon>
            <span v-if="selectedLead.phone_2" class="contactText ml-3" @click="contactLinks('phone', selectedLead.phone_2)">{{formatPhoneNumber(selectedLead.phone_2)}}</span>
            <span v-if="selectedLead.phone_2" class="contactText ml-2">({{selectedLead.first_name + ' ' + [selectedLead.phone_type_2 ? selectedLead.phone_type_2 : '']}})</span>
          </v-layout>
          <v-layout mt-2 v-if="selectedLead.email">
            <v-icon>email</v-icon>
            <span class="contactText ml-3 primary--text" style="cursor: pointer" @click="contactLinks('email', selectedLead.email)">{{selectedLead.email ? selectedLead.email : ''}}</span>
            <span class="contactText ml-2">({{selectedLead.first_name}} Email)</span>
          </v-layout>
          <!-- Secondary Contact Details -->
          <v-layout mt-3 v-if="selectedLead.secondaryContact_phone_1">
            <v-icon v-if="selectedLead.secondaryContact_phone_1">phone</v-icon>
            <span v-if="selectedLead.secondaryContact_phone_1" class="contactText ml-3" @click="contactLinks('phone', selectedLead.secondaryContact_phone_1)">{{formatPhoneNumber(selectedLead.secondaryContact_phone_1)}}</span>
            <span v-if="selectedLead.secondaryContact_phone_1" class="contactText ml-2">({{selectedLead.secondaryContact_first_name + ' ' + [selectedLead.secondaryContact_phone_type_1 ? selectedLead.secondaryContact_phone_type_1 : '']}})</span>
            <v-icon v-if="selectedLead.secondaryContact_phone_2" class="ml-3">phone</v-icon>
            <span v-if="selectedLead.secondaryContact_phone_2" class="contactText ml-3" @click="contactLinks('phone', selectedLead.secondaryContact_phone_2)">{{formatPhoneNumber(selectedLead.secondaryContact_phone_2)}}</span>
            <span v-if="selectedLead.secondaryContact_phone_2" class="contactText ml-2">({{selectedLead.secondaryContact_first_name + ' ' + [selectedLead.secondaryContact_phone_type_2 ? selectedLead.secondaryContact_phone_type_2 : '']}})</span>
          </v-layout>
          <v-layout mt-2 v-if="selectedLead.secondaryContact_email">
            <v-icon>email</v-icon>
            <span class="contactText ml-3 primary--text" style="cursor: pointer" @click="contactLinks('email', selectedLead.secondaryContact_email)">{{selectedLead.secondaryContact_email ? selectedLead.secondaryContact_email : ''}}</span>
            <span class="contactText ml-2">({{selectedLead.secondaryContact_first_name}} Email)</span>
          </v-layout>
        </div>
        <!-- Opportunity Notes -->
        <v-toolbar class="mt-2" flat height="50px">
          <v-toolbar-title>Notes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="showNoteForm = true" icon>
            <v-icon>add</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="ml-4">
          <v-layout v-if="showNoteForm" row wrap>
            <v-flex xs12 pt-3 pl-3 pr-3>
              <v-textarea outline v-model="newNote" label="Add A New Note"></v-textarea>
            </v-flex>
            <v-layout ml-3 mb-3 row>
              <v-btn @click="addNote" class="primary">SAVE NOTE</v-btn>
              <v-btn @click="showNoteForm = false" class="secondary">CANCEL</v-btn>
            </v-layout>
          </v-layout>
          <v-divider v-if="showNoteForm" class="mb-3"></v-divider>
          <v-list three-line>
            <template v-for="(note, index) in selectedLeadNotes">
              <v-list-tile :key="index" avatar>
                <v-list-tile-avatar>
                  <v-avatar><v-tooltip top><avatar slot="activator" :username="note.createdBy.first_name + ' ' + note.createdBy.last_name" :src="note.createdBy.avatar ? note.createdBy.avatar : undefined"></avatar>{{ note.createdBy.first_name + ' ' + note.createdBy.last_name }}</v-tooltip></v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="primary--text font-weight-bold">{{ note.created_date.seconds | moment("from") }} {{ note.created_date.seconds | moment("MM/DD/YY") }}</v-list-tile-title>
                  <v-list-tile-sub-title class="black--text">{{ note.note }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action><v-btn v-if="note.source !== 'Project'" @click="editNote(note)" icon flat><v-icon>edit</v-icon></v-btn><v-btn v-if="note.source !== 'Project'" @click="deleteNote(note)" icon flat><v-icon>close</v-icon></v-btn></v-list-tile-action>
              </v-list-tile>
            </template>
            <span v-if="!selectedLeadNotes || selectedLeadNotes.length < 1" class="ml-3 caption">There are no notes for this lead</span>
          </v-list>
        </div>
        <!-- End: Opportunity Notes -->
        <!-- Contact / Mailing Address -->
        <v-toolbar class="mt-2" height="48px" flat v-if="selectedLead.address || selectedLead.city || selectedLead.state || selectedLead.zip">
          <v-toolbar-title>Contact / Mailing Address</v-toolbar-title>
        </v-toolbar>
        <div class="contactText pl-4" v-if="selectedLead.address || selectedLead.city || selectedLead.state || selectedLead.zip">
          <v-layout row>
            <span>{{selectedLead.address}}</span>
          </v-layout>
          <v-layout row>
            <span>{{selectedLead.city}} {{selectedLead.state}}, {{selectedLead.zip}}</span>
          </v-layout>
        </div>
        <!-- Property Address -->
        <v-toolbar class="mt-2" height="48px" flat v-if="selectedLead.opportunities.address || selectedLead.opportunities.city || selectedLead.opportunities.state || selectedLead.opportunities.zip">
          <v-toolbar-title>Property Address</v-toolbar-title>
        </v-toolbar>
        <div class="contactText pl-4" v-if="selectedLead.opportunities.address || selectedLead.opportunities.city || selectedLead.opportunities.state || selectedLead.opportunities.zip">
          <v-layout row>
            <span>{{selectedLead.opportunities.address}}</span>
          </v-layout>
          <v-layout row>
            <span>{{selectedLead.opportunities.city}} {{selectedLead.opportunities.state}}, {{selectedLead.opportunities.zip}}</span>
          </v-layout>
          <v-layout row>
            <v-flex v-if="selectedLead.opportunities.building_dept"><span class="font-weight-bold">Building Dep: </span><span>{{selectedLead.opportunities.building_dept}}</span></v-flex>
            <v-flex v-if="selectedLead.opportunities.hoa"><span class="font-weight-bold">HOA: </span><span>{{selectedLead.opportunities.hoa}}</span></v-flex>
            <v-flex v-if="selectedLead.opportunities.gate_code"><span class="font-weight-bold">Gate Code: </span><span>{{selectedLead.opportunities.gate_code}}</span></v-flex>
          </v-layout>
        </div>
        <!-- Opportunity Details -->
        <v-toolbar class="mt-2" height="48px" flat>
          <v-toolbar-title>Opportunity Details</v-toolbar-title>
        </v-toolbar>
        <div class="contactText pl-4">
          <v-layout row wrap v-if="selectedLead.opportunities.property_survey || selectedLead.opportunities.other_design">
            <v-flex v-if="selectedLead.opportunities.property_survey"><span class="font-weight-bold">Property Survey: </span><span>{{selectedLead.opportunities.property_survey}}</span></v-flex>
            <v-flex v-if="selectedLead.opportunities.other_designs"><span class="font-weight-bold">Other Designs: </span><span>{{selectedLead.opportunities.other_designs}}</span></v-flex>
          </v-layout>
          <v-layout row wrap v-if="selectedLead.opportunities.financing">
            <v-flex><span class="font-weight-bold">Financing: </span><span>{{selectedLead.opportunities.financing}}</span></v-flex>
          </v-layout>
        </div>
        <!-- Builder Information -->
        <v-toolbar class="mt-2" height="48px" flat v-if="selectedLead.opportunities.builder || selectedLead.opportunities.builder_contact">
          <v-toolbar-title>Builder Information</v-toolbar-title>
        </v-toolbar>
        <div class="contactText pl-4">
          <v-layout row wrap>
            <v-flex v-if="selectedLead.opportunities.builder"><span class="font-weight-bold">Builder: </span><span>{{selectedLead.opportunities.builder}}</span></v-flex>
            <v-flex v-if="selectedLead.opportunities.builder_contact"><span class="font-weight-bold">Builder Contact: </span><span>{{selectedLead.opportunities.builder_contact}}</span></v-flex>
          </v-layout>
        </div>
        <!-- Description of Work -->
        <v-toolbar class="mt-2" height="48px" flat v-if="selectedLead.opportunities.description">
          <v-toolbar-title>Description of Work</v-toolbar-title>
        </v-toolbar>
        <div class="contactText pl-4">
          <v-layout row wrap>
            <v-flex><span>{{selectedLead.opportunities.description}}</span></v-flex>
          </v-layout>
        </div>
        <!-- General Project Notes -->
        <v-toolbar class="mt-2" height="48px" flat v-if="selectedLead.opportunities.projectNotes">
          <v-toolbar-title>General Project Notes</v-toolbar-title>
        </v-toolbar>
        <div class="contactText pl-4">
          <v-layout row wrap>
            <v-flex><span>{{selectedLead.opportunities.projectNotes}}</span></v-flex>
          </v-layout>
        </div>
      </v-flex>
      </div>
      <!-- Reporting: Rep Level -->
      <div :class="onMobile ? '' : 'scroll'" :style="onMobile ? '' : 'width: 60%; height: 100%'" v-if="showLeadStats">
      <v-flex xs12 :class="mobileDetailView">
        <v-layout row ml-3>
          <!-- Mobile Toolbar -->
          <v-toolbar @click="mobileView = 'leads'" class="hidden-md-and-up" flat height="48px" dark color="secondary">
            <v-icon>chevron_left</v-icon>
            <v-toolbar-title>Back to Leads List</v-toolbar-title>
          </v-toolbar>
        </v-layout>
          <!-- End: Mobile Toolbar -->
        <v-layout row ml-3>
          <v-toolbar flat height="48px" class="cyan" dark>
            <v-toolbar-title>Reporting for {{leadStats[0].repName}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark outline flat @click="showSummary = !showSummary"><v-icon left>line_weight</v-icon>{{showSummary ? 'Hide Summary' :  'Show Summary'}}</v-btn>
          </v-toolbar>
        </v-layout>
        <!-- Conversion Summary -->
        <v-data-table :headers="conversionHeaders" :items="conversionSummary" v-if="showSummary" :pagination.sync="pagination">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.closed_date.seconds| moment("MMMM Do YYYY") }}</td>
            <td >{{ props.item.name }}</td>
            <td >{{ props.item.source }}</td>
            <td>
              <v-layout row wrap>
                <v-tooltip top>
                  <span>{{props.item.sales_rep.first_name + ' ' + props.item.sales_rep.last_name}}</span>
                  <v-avatar slot="activator" style="cursor: pointer">
                    <avatar :username="props.item.sales_rep.first_name + ' ' + props.item.sales_rep.last_name" :src="props.item.sales_rep.avatar ? props.item.sales_rep.avatar : undefined"></avatar>
                </v-avatar>
                </v-tooltip>
              </v-layout>
            </td>
            <td class="text-xs-center">{{ formatCurrency(props.item.contract_amount) }}</td>
          </template>
        </v-data-table>
        <!-- End: Conversion Summary -->
        <!-- Start Dashboards -->
        <template v-for="(stats, index) in leadStats">
          <div :key="index">
            <v-layout row mt-3 ml-3>
              <h2><span class="body-1 font-weight-bold">{{stats.type}}</span></h2>
            </v-layout>
            <v-layout row wrap ml-3 mt-2 justify-space-around>
              <v-layout column class="outlineBox text-xs-center">
                <span class="display-2 font-weight-thin">{{formatCurrency(stats.totalSales)}}</span>
                <span class="mt-2 caption font-weight-bold">TOTAL SALES: {{ stats.totalConversions }}</span>
              </v-layout>
              <v-layout column class="outlineBox text-xs-center">
                <span class="display-2 font-weight-thin">{{stats.totalLeads}}</span>
                <span class="mt-2 caption font-weight-bold">TOTAL LEADS</span>
              </v-layout>
              <v-layout column class="outlineBox text-xs-center">
                <span class="display-2 font-weight-thin">{{stats.conversions}}</span>
                <span class="mt-2 caption font-weight-bold">LEAD CONVERSION</span>
              </v-layout>
            </v-layout>
            <v-layout class="mb-5 text-xs-small outlineBox">
              <v-layout row class="text-xs-small">
                <span class="subheading font-weight-bold">LEAD SOURCES</span>
              </v-layout>
              <v-layout row wrap justify-space-around>
                <v-flex mb-3 xs2 v-for="source in stats.leadSources" :key="source.name">
                  <v-layout column class="text-xs-center" flex>
                    <span class="display-2 font-weight-thin">{{source.value}}</span>
                    <div class="text-xs-center"><v-btn class="primary primary--text" outline>{{source.won}} WON</v-btn></div>
                    <span class="mt-2 caption font-weight-bold">{{source.name}}</span>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
          </div>
        </template>
      </v-flex>
      </div>
<!-- End Reporting: Rep Level -->
      </v-layout>
    <!-- Create Lead Dialog -->
      <v-dialog max-width="800px" persistent v-model="createLeadDialog">
        <create-contact v-if="createLeadDialog" @newLead="newLead" :newLeadType="newLeadType" :ifBuilder="propBuilder" :type="'Lead'" @closeDialog="createLeadDialog = false" @closeCreateDialog="createLeadDialog = false"/>
      </v-dialog>
    <!-- End: Create Lead Dialog -->
    <!-- Edit Lead Dialog -->
      <v-dialog max-width="800px" persistent v-model="editLeadDialog">
        <create-contact v-if="editLeadDialog" @deleteLead="deleteLead" :type="'EditLead'" :ifBuilder="propBuilder" :selectedLead="this.selectedLead" @closeDialog="editLeadDialog = false" @closeCreateDialog="editLeadDialog = false" @editLead="editLead"/>
      </v-dialog>
    <!-- End: Edit Lead Dialog -->
    <!-- Edit Note Dialog -->
      <v-dialog max-width="800px" persistent v-model="editNoteDialog">
        <v-toolbar flat class="secondary white--text"> 
          <v-toolbar-title>Edit Lead Note</v-toolbar-title>
        </v-toolbar>
         <v-container style="background-color: white">
           <v-textarea v-model="editedNote"></v-textarea>
           <v-btn class="primary" @click="saveEditNote">Save Note</v-btn><v-btn class="ml-3 secondary" @click="editNoteDialog = false">Cancel</v-btn>
         </v-container>
      </v-dialog>
    <!-- End: Edit Note Dialog -->
    <!-- Conversion Window -->
    <v-dialog class="conversionWindow" max-width="600px" v-model="showConversionWindow">
      <v-container v-if="showConversionWindow" class="conversionWindow text-xs-center">
        <v-layout column>
          <span class="success--text display-2 font-weight-thin">Congratulations!</span>
          <span class="secondary--text mt-4 subheading">{{selectedLead.opportunities.revertedToLeads ? 'Restoring Project For' : 'Moving'}}</span>
          <span class="primary--text display-1 font-weight-thin">{{selectedLead.opportunities.job_name ? selectedLead.opportunities.job_name + ' (' + selectedLead.company_name + ')' : selectedLead.company_name ? selectedLead.company_name : selectedLead.secondaryContact_first_name ? selectedLead.first_name + ' ' + selectedLead.last_name + ' & ' + selectedLead.secondaryContact_first_name + ' ' + selectedLead.secondaryContact_last_name : selectedLead.first_name + ' ' + selectedLead.last_name}}</span>
          <span class="secondary--text subheading">{{selectedLead.opportunities.revertedToLeads ? '' : 'To The Pre-Construction Phase'}}</span>
          <v-layout row class="mt-4" v-if="!loading">
            <v-flex v-if="!selectedLead.opportunities.revertedToLeads" xs6>
              <v-text-field v-model="projectName" label="Enter a Project Name"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-layout row>
                <!-- <span class="success--text display-2 font-weight-bold mr-2">$</span><v-text-field mask="#########" outline class="title" solo v-model="contractAmount" label="Enter Contract Amount"></v-text-field> -->
                <span class="success--text display-2 font-weight-bold mr-2">$</span><v-currency-field v-bind="currency_config" v-model="contractAmount" label="Enter Contract Amount"></v-currency-field>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn v-if="submitError" outline class="error error--text">{{selectedLead.opportunities.revertedToLeads ? 'Contract Amount Before Proceeding!' : 'Enter a Project Name AND Contract Amount Before Proceeding!'}}</v-btn>
          <span v-if="!loading && !selectedLead.opportunities.revertedToLeads" class="body-2 mt-3 font-weight-bold">This will convert the lead to a customer and build the Pre-Construction tasks.</span>
          <span v-if="!loading && selectedLead.opportunities.revertedToLeads" class="body-2 mt-3 font-weight-bold">This will restore the project (with its tasks) as it was before being moved back to a lead.</span>
          <v-layout column justify-center v-if="loading">
            <div class="text-xs-center"><v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular></div>
            <span class="caption">Loading Project...</span>
          </v-layout>
          <v-layout row wrap mt-3>
            <v-btn :disabled="disableButton || loading" v-if="!selectedLead.opportunities.revertedToLeads" @click="executeConversion" class="primary">Send To Pre-Construction Phase</v-btn>
            <v-btn v-if="selectedLead.opportunities.revertedToLeads" @click="executeRestoreProject" :disabled="loading" class="primary">Restore Project</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="disableButton" @click="showConversionWindow = false" class="secondary">Cancel</v-btn>
            <span v-if="disableButton">Creating Project...</span>
          </v-layout>
        </v-layout>
      </v-container>
    </v-dialog>
    <!-- End: Conversion Window -->
    <!-- Add New Lead Dialog -->
    <v-dialog max-width="600px" v-model="addNewLeadDialog">
      <v-toolbar flat dark class="secondary">
        <v-toolbar-title>Create New Lead</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="ml-4" dark flat icon @click="addNewLeadDialog = false"><v-icon>cancel</v-icon></v-btn>
      </v-toolbar>
        <v-container class="white">
          <v-layout py-2 row wrap justify-space-around>
            <v-btn @click="newLeadType = 'New'; propBuilder = false; createLeadDialog = true; addNewLeadDialog = false" class="primary">For New Lead</v-btn>
            <v-btn @click="newLeadType = 'Existing'; propBuilder = false; createLeadDialog = true; addNewLeadDialog = false" class="primary">For Existing Customer</v-btn>
            <v-btn @click="newLeadType = 'Builder'; propBuilder = true; createLeadDialog = true; addNewLeadDialog = false" class="primary">For Builder</v-btn>
          </v-layout>
        </v-container>
    </v-dialog>
    <!-- End: Add New Lead Dialog -->
    </v-container>
  </div>
</template>

<script>
import CreateContact from '../contacts/CreateContact'
import CustomerLead from './CustomerLead'
import Avatar from 'vue-avatar'
import _ from 'lodash'

export default {
  mounted () {
    this.$store.dispatch('convertedLeads')
    if (this.user.permissions.others.showAllLeads) {
      this.$store.dispatch('getLeads', {user: null, showInactive: false})
    } else {
      this.$store.dispatch('getLeads', {user: this.user.id, showInactive: false})
      this.statsUser = this.$store.getters.user.id
    }
    if (window.innerWidth < 1024) {
      this.onMobile = true
    }
  },
  data () {
    return {
      disableButton: false,
      pagination: {
        sortBy: 'Date', // The field that you're sorting by
        descending: true
      },
      userFilter: null,
      currency_config: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      newLeadType: true,
      propBuilder: false,
      search: '',
      onMobile: false,
      editedNote: null,
      noteBeingEdited: null,
      editNoteDialog: false,
      showSummary: false,
      conversionHeaders: [{text: 'Date', value: 'created_date.seconds'}, {text: 'Name', value: 'name'}, {text: 'Source', value: 'source'}, {text: 'Sales Rep', value: 'sales_rep'}, {text: 'Contact Amount', value: 'contract_amount'}],
      showLeadStats: true,
      statsUser: null,
      selectedHeader: null,
      expand: true,
      mobileView: 'leads', // 'leads' or 'detail'
      projectId: null,
      submitError: false,
      pageLoaded: false,
      projectName: null,
      contractAmount: 0,
      showConversionWindow: false,
      leadStatus: ['New Lead', 'In Progress', 'On Hold', 'Closed - Not Won'],
      newNote: null,
      showInactive: false,
      showNoteForm: false,
      selectedLead: null,
      editLeadDialog: false,
      createLeadDialog: false,
      addNewLeadDialog: false
    }
  },
  watch: {
    leadsList () {
      if (this.leadsList && this.leadsList.length > 0) {
        if (!this.selectedLead) {
          this.selectedLead = this.leadsList[1]
          if (this.leadsList.length > 0) {
            this.$store.dispatch('getLeadNotes', this.leadsList[1])
          }
        } else {
          const leadsIndex = this.leadsList.findIndex(i => i.id === this.selectedLead.id)
          this.selectedLead = this.leadsList[leadsIndex]
        }
      }
    },
    selectedLead () {
      if (!this.selectedLead.allOpps) {
        this.selectedLead.allOpps = [Object.assign(this.selectedLead.opportunities)]
        this.selectedLead.opportunities.index = 0
      }
    }
  },
  computed: {
    usersWithLeads () {
      const list = this.leadsList
      let userList = [{ name: '- Show All -', userId: '' }]
      list.forEach(lead => {
        if (lead.header) {
          userList.push({ name: lead.header, userId: lead.userId })
        }
      })
      return userList
    },
    userPermissions () {
      if (this.user.permissions.others.showAllLeads) {
        return null
      } else {
        return this.user.id
      }
    },
    conversionSummary () {
      let wonLeads = this.$store.getters.convertedLeads
      let summary = null
      if (this.statsUser) {
        summary = wonLeads.filter(f => f.sales_rep === this.statsUser)
      } else {
        summary = wonLeads.filter(f => f.sales_rep)
      }
      let conversionSummary = []
      summary.forEach(lead => {
        const user = this.users.filter(f => f.id === lead.sales_rep)
        conversionSummary.push({...lead, sales_rep: user[0]})
      })
      return _.orderBy(conversionSummary, 'closed_date.seconds', 'desc')
    // return DAte Name and Contact Amount
    },
    leadStats () {
      let leadStats = []
      let userId = null
      let user = null
      if (this.statsUser) {
        userId = this.statsUser
        user = this.users.filter(f => f.id === userId)[0]
        user = user.first_name + ' ' + user.last_name
      } else {
        user = 'All Sales Reps'
      }
      // ----------------   Get Leads ------------------------------------------------------
      let leads = this.leads
      if (this.statsUser) {
        leads = leads.filter(f => f.sales_rep && f.sales_rep.id === userId)
      }
      let getConversionLeads = this.conversionSummary
      let wonLeads = getConversionLeads.map(m => ({...m, status: 'Closed - Won'}))
      leads = leads.concat(wonLeads)
      leads = leads.map(m => ({...m, contract_amount: m.contract_amount ? m.contract_amount : 0}))
      // Loop Over Selected Date Ranges
      // let leadsThisMonth = leads.filter(f => f.created_date.seconds > new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() / 1000)
      let leadsThisMonth = leads.filter((f) => {
        return (f.status === 'Closed - Won' && f.closed_date.seconds > new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() / 1000) ||
        ((!f.status || f.status !== 'Closed - Won') && f.created_date.seconds > new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() / 1000)
      })
      let last30Days = leads.filter((f) => {
        return (f.status === 'Closed - Won' && f.closed_date.seconds > Math.floor(new Date().setDate(new Date().getDate() - 30) / 1000)) ||
        ((!f.status || f.status !== 'Closed - Won') && f.created_date.seconds > Math.floor(new Date().setDate(new Date().getDate() - 30) / 1000))
      })
      let leadsThisQuarter = leads.filter((f) => {
        return (f.status === 'Closed - Won' && f.closed_date.seconds > new Date(new Date().getFullYear(), Math.floor((new Date().getMonth() / 3)) * 3, 1).getTime() / 1000) ||
        ((!f.status || f.status !== 'Closed - Won') && f.created_date.seconds > new Date(new Date().getFullYear(), Math.floor((new Date().getMonth() / 3)) * 3, 1).getTime() / 1000)
      })
      let leadsThisYear = leads.filter((f) => {
        return (f.status === 'Closed - Won' && f.closed_date.seconds > new Date(new Date().getFullYear(), 0, 1).getTime() / 1000) ||
        ((!f.status || f.status !== 'Closed - Won') && f.created_date.seconds > new Date(new Date().getFullYear(), 0, 1).getTime() / 1000)
      })
      const leadPeriods = [{name: 'THIS MONTH', leads: leadsThisMonth}, {name: 'LAST 30 DAYS', leads: last30Days}, {name: 'THIS QUARTER', leads: leadsThisQuarter}, {name: 'THIS YEAR', leads: leadsThisYear}]/* ,{name: 'ALL TIME', leads: leads} Removed as Per Wes 2020-05-27 */
      leadPeriods.forEach(period => {
        // Get Conversions
        const convertedLeads = period.leads.filter(f => f.status === 'Closed - Won')
        let totalSales = convertedLeads.length > 0 ? convertedLeads.reduce((prev, curr) => prev + Number(curr.contract_amount), 0) : 0
        // Get Lead Sources and Percentages
        let leadSources = _.groupBy(period.leads, 'source')
        // let leadSourceKeys = Object.keys(leadSources)
        let getSourceValues = []
        Object.keys(leadSources).forEach(key => {
          getSourceValues.push({name: key, value: leadSources[key].length, won: period.leads.filter(f => f.source === key && f.status === 'Closed - Won').length})
        })
        leadSources = Object.assign([], _.orderBy(getSourceValues, 'value', 'desc'))
        // Finished Object
        leadStats.push({type: period.name, repName: user, totalLeads: period.leads.length, conversions: Math.round(convertedLeads.length / period.leads.length * 100) ? Math.round(convertedLeads.length / period.leads.length * 100) + '%' : '0%', totalSales: totalSales, totalConversions: convertedLeads ? convertedLeads.length : 0, leadSources: leadSources})
      })
      return leadStats
    },
    mobileLeadsView () {
      if (this.mobileView === 'detail') {
        return 'hidden-sm-and-down'
      }
    },
    mobileDetailView () {
      if (this.mobileView === 'leads') {
        return 'hidden-sm-and-down'
      }
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    selectedLeadNotes () {
      return _.orderBy(this.$store.getters.leadNotes, 'created_date.seconds', 'desc')
    },
    users () {
      return this.$store.getters.userList.concat(this.$store.getters.inactiveUsers)
    },
    leadsList () {
      let leads = []
      let leadList = []
      if (this.showInactive !== true) {
        leads = this.leads.filter(f => f.status !== 'Closed - Not Won')
      } else {
        leads = this.leads.filter(f => f.status === 'Closed - Not Won')
      }
      // Get Distinct Users WITH ACTIVE Leads
      let users = []
      if (this.user.permissions.others.showAllLeads) {
        // Hide Users Not Marked as Sales Reps
        if (!this.showInactive) {
          leads = leads.filter(f => f.sales_rep && f.sales_rep.if_sales_rep === true)
        }
        users = leads.map(m => m.sales_rep && m.sales_rep.first_name + ' ' + m.sales_rep.last_name)
      } else {
        users.push(this.user.first_name + ' ' + this.user.last_name)
      }
      users = Array.from(new Set(users))
      // Get Distinct Users WITH NO ACTIVE Leads
      const customers = this.$store.getters.getContactSearchList
      let inactiveUsers = []
      this.users.forEach(user => {
        let allLeads = this.leads.filter(f => f.sales_rep && f.sales_rep.id === user.id)
        let allCustomers = customers.filter(f => f.sales_rep === user.id)
        allCustomers = allCustomers.map(m => { return {...m, status: 'Closed - Won'} })
        allLeads = allLeads.concat(allCustomers)
        if (!this.showInactive) {
          allLeads = allLeads.filter(f => f.sales_rep.if_sales_rep === true)
        }
        const inactiveLeads = allLeads.filter(f => f.status === 'Closed - Won' || f.status === 'Closed - Not Won')
        if (allLeads.length > 0 && allLeads.length === inactiveLeads.length) {
          inactiveUsers.push(user)
        }
      })
      // Iterate Through The Lead Owners Followed By Their Leads
      users.forEach(user => {
        if (user) {
          const userId = this.users.filter(f => f.first_name + ' ' + f.last_name === user)[0].id
          const userLeads = leads.filter(f => f.sales_rep && f.sales_rep.first_name + ' ' + f.sales_rep.last_name === user)
          leadList.push({header: user, userId: userId, totalLeads: userLeads.length, expand: true})
          userLeads.forEach(lead => {
            leadList.push(lead)
            leadList.push({divider: true})
          })
        }
      })
      if (this.user.permissions.others.showAllLeads) {
        inactiveUsers.forEach(user => {
          leadList.push({header: user.first_name + ' ' + user.last_name, userId: user.id, totalLeads: 0, expand: true})
        })
        return leadList
      } else {
        return leadList
      }
    },
    leads () {
      // ---- Push Leads "On Hold" To Buttom Of List ----
      let getStoreLeads = this.$store.getters.leads
      getStoreLeads.forEach((lead, i) => {
        if (lead.opportunities.status === 'On Hold') {
          getStoreLeads[i].statusOrder = 1
        } else {
          getStoreLeads[i].statusOrder = 0
        }
      })
      let getLeads = _.orderBy(getStoreLeads, ['statusOrder', 'created_date.seconds'], ['asc', 'desc'])
      // ---- END: Push Leads "On Hold" To Buttom Of List ----
      let leadList = []
      getLeads.forEach(lead => {
        if (lead.opportunities.sales_rep && !lead.opportunities.deleted) {
          const rep = this.users.filter(f => f.id === lead.opportunities.sales_rep)
          leadList.push({...lead, sales_rep: rep[0], opportunities: lead.opportunities, status: lead.opportunities.status, source: lead.opportunities.source})
        }
      })
      return leadList
    },
    filteredLeadsList () {
      let filteredUserList = []
      if (this.userFilter && this.userFilter.userId !== '') {
        this.leadsList.forEach(lead => {
          if ((lead.userId === this.userFilter.userId) || (lead.sales_rep && lead.sales_rep.id === this.userFilter.userId)) {
            filteredUserList.push(lead)
          }
        })
        return filteredUserList
      } else {
        return this.leadsList
      }
    }
  },
  methods: {
    ifInactiveToggled () {
      if (this.showInactive) {
        if (this.user.permissions.others.showAllLeads) {
          this.$store.dispatch('getLeads', {user: null, showInactive: true})
        } else {
          this.$store.dispatch('getLeads', {user: this.user.id, showInactive: true})
        }
      }
      if (!this.showInactive) {
        if (this.user.permissions.others.showAllLeads) {
          this.$store.dispatch('getLeads', {user: null, showInactive: false})
        } else {
          this.$store.dispatch('getLeads', {user: this.user.id, showInactive: false})
        }
      }
    },
    fullLeadName (lead) {
      return lead.secondaryContact_first_name ? lead.last_name + ', ' + lead.first_name + ' & ' + lead.secondaryContact_last_name + ', ' + lead.secondaryContact_first_name : lead.last_name + ', ' + lead.first_name
    },
    notifyNewLead (lead) {
      const user = this.users.filter(f => f.id === lead.opportunities.sales_rep)
      const salesRep = user[0]
      // console.log('Email Message', {emails: [salesRep.email], emailSubject: 'New Lead Assigned', title: 'New Lead: ' + lead.first_name + ' ' + lead.last_name, message: 'You have a new lead assigned to you! Login to review.', url: this.$store.getters.clientSettings.baseUrl + '/leads/', icon: 'people_outline'})
      this.$store.dispatch('notify', {emails: [salesRep.email], emailSubject: 'New Lead Assigned', title: 'New Lead: ' + lead.first_name + ' ' + lead.last_name, message: 'You have a new lead assigned to you! Login to review.', url: this.$store.getters.clientSettings.baseUrl + '/leads/', icon: 'people_outline'})
    },
    saveEditNote () {
      const noteIndex = this.selectedLead.allOpps[this.selectedLead.opportunities.index].notes.findIndex(n => n.note === this.noteBeingEdited.note)
      this.selectedLead.allOpps[this.selectedLead.opportunities.index].notes[noteIndex].note = this.editedNote
      this.$store.dispatch('editLeadNote', {selectedLead: this.selectedLead, fullNote: this.noteBeingEdited, note: this.editedNote})
      this.editNoteDialog = false
    },
    editNote (note) {
      this.noteBeingEdited = note
      this.editedNote = note.note
      this.editNoteDialog = true
    },
    editLead () {
      this.editLeadDialog = false
    },
    deleteLead () {
      this.selectedLead.allOpps[this.selectedLead.opportunities.index].deleted = true
      this.selectedLead.allOpps[this.selectedLead.opportunities.index].active = false
      let payload = {contactId: this.selectedLead.id, contactName: this.selectedLead.first_name + ' ' + this.selectedLead.last_name, update: {opportunities: this.selectedLead.allOpps}, log: {changedFrom: {deleted: false}, changedTo: {deleted: true}}, logMessage: 'changed opportunity deletion to', refresh: true}
      this.$store.dispatch('updateLead', {...payload, user: this.userPermissions, showInactive: this.showInactive})
      // Set First Slot as Active After Delete
      this.selectedLead = this.leadsList[1]
      this.$store.dispatch('getLeadNotes', this.leadsList[1])
      this.editLeadDialog = false
    },
    getLeadNotes (lead) {
      this.$store.dispatch('getLeadNotes', lead)
    },
    newLead (lead) {
      lead.created_date = {seconds: new Date().getTime()}
      lead.opportunities = lead.opportunities[0]
      lead.opportunities.created_date = {seconds: new Date().getTime()}
      this.$store.dispatch('newLead', lead)
      this.notifyNewLead(lead)
    },
    executeRestoreProject () {
      if (!this.contractAmount) {
        this.submitError = true
      } else {
        // Update Contact Details
        let projectData = {projectId: this.selectedLead.opportunities.revertedToLeads, budget_max: this.selectedLead.opportunities.budget_max, budget_min: this.selectedLead.opportunities.budget_min, builder: this.selectedLead.opportunities.builder, builder_contact: this.selectedLead.opportunities.builder_contact, building_dept: this.selectedLead.opportunities.building_dept, contract_amount: this.contractAmount, description: this.selectedLead.opportunities.description, financing: this.selectedLead.opportunities.financing, gate_code: this.selectedLead.opportunities.gate_code, hoa: this.selectedLead.opportunities.hoa, notes: this.selectedLead.opportunities.notes, other_designs: this.selectedLead.opportunities.other_designs, property_survey: this.selectedLead.opportunities.property_survey, revertedToLeads: false, reinstated_date: new Date()}
        // Update Opportunities Data
        let opps = this.selectedLead.allOpps
        opps[this.selectedLead.opportunities.index] = {...opps[this.selectedLead.opportunities.index], status: 'Closed - Won', closed_date: new Date(), active: false, contract_amount: this.contractAmount, revertedToLeads: null}
        let payload = {projectData: projectData, contactId: this.selectedLead.id, notes: this.selectedLeadNotes, update: opps, log: {changedFrom: this.selectedLead.status, changedTo: 'Closed - Won'}, logMessage: 'converted lead back to project and status changed to'}
        this.$store.dispatch('restoreProject', payload)
        // Reset Windows
        this.submitError = false
        this.showConversionWindow = false
        this.$router.push('/project/' + projectData.projectId)
      }
    },
    executeConversion () {
      this.disableButton = true
      if (!this.projectName || !this.contractAmount) {
        this.submitError = true
      } else {
        // Create ProjectId
        let milliseconds = String((new Date()).getTime())
        this.projectId = milliseconds + '-' + Math.floor(Math.random() * 1000)
        // Update Contact Details
        // Change Opportunities Settings
        this.selectedLead.allOpps[this.selectedLead.opportunities.index] = {...this.selectedLead.allOpps[this.selectedLead.opportunities.index], status: 'Closed - Won', closed_date: new Date(), contract_amount: this.contractAmount, active: false, project: this.projectId}
        let payload = {contact: this.selectedLead, contactId: this.selectedLead.id, contactName: this.selectedLead.first_name ? this.selectedLead.first_name + ' ' + this.selectedLead.last_name : this.selectedLead.company_name, update: {type: this.selectedLead.type === 'Builder' ? 'Builder' : 'Customer', opportunities: this.selectedLead.allOpps}, log: {changedFrom: this.selectedLead.status, changedTo: 'Closed - Won'}, logMessage: 'converted to customer and status changed to'}
        this.$store.dispatch('updateLead', payload)
        // Execute Task List
        this.createProjectAndTasks()
        // Reset Windows
        this.submitError = false
        // this.notifyAllUsers()
      }
    },
    notifyAllUsers () {
      let users = Object.assign([], this.$store.getters.userList)
      users.splice(users.findIndex(i => i.id === this.$store.getters.user.id), 1)
      let emails = users.map(user => user.email)
      // Filter Out The Current User
      if (emails.length > 0) {
        const emailSubject = 'New Customer In Pre-Construction Phase'
        const customer = this.selectedLead.opportunities.job_name ? this.selectedLead.opportunities.job_name + ' (' + this.selectedLead.company_name + ')' : this.selectedLead.company_name ? this.selectedLead.company_name : this.selectedLead.first_name + ' ' + this.selectedLead.last_name
        const title = 'Congratulations Team! ' + this.user.first_name + ' ' + this.user.last_name + ' has started Pre-Construction for the customer: ' + customer
        const message = 'There is a new project started for the customer: ' + customer + '. Please review if you have required tasks due.'
        const url = this.$store.getters.clientSettings.baseUrl
        const icon = 'ballot'
        this.$store.dispatch('notify', {emails, emailSubject, title, message, url, icon})
      }
    },
    createProjectAndTasks () {
      this.createProject()
      // const payload = {projectId: this.projectId, projectName: this.projectName, taskTemplate: 'Pre-Construction', startDate: new Date()}
      // this.$store.dispatch('getTaskList', payload) // We are no longer creating tasks immediatly but instead using templates AFTER project creation
      this.sendNotes()
    },
    closeConversionDialog (projectData) {
      this.showConversionWindow = false
      // this.$router.push('/project/' + projectData.id)
    },
    createProject () {
      const project = {id: this.projectId, status: 'Pre-Construction', name: this.projectName, contract_amount: this.contractAmount, start_date: new Date(), completed_date: null, building_dept: this.selectedLead.opportunities.building_dept, property_survey: this.selectedLead.opportunities.property_survey, other_designs: this.selectedLead.opportunities.other_designs, financing: this.selectedLead.opportunities.financing, budget_min: this.selectedLead.opportunities.budget_min, budget_max: this.selectedLead.opportunities.budget_max, address: this.selectedLead.opportunities.address, city: this.selectedLead.opportunities.city, state: this.selectedLead.opportunities.state, zip: this.selectedLead.opportunities.zip, gate_code: this.selectedLead.opportunities.gate_code, hoa: this.selectedLead.opportunities.hoa, description: this.selectedLead.opportunities.description, notes: this.selectedLead.opportunities.notes, builder: this.selectedLead.opportunities.builder, builder_contact: this.selectedLead.opportunities.builder_contact, source: this.selectedLead.opportunities.source, referred_by: this.selectedLead.opportunities.referred_by, sales_rep: this.selectedLead.opportunities.sales_rep}
      const projectData = {...project, files: [], contact_id: this.selectedLead.id}
      console.log('Project Data', projectData)
      this.$store.dispatch('createProject', projectData)
      setTimeout(this.closeConversionDialog(projectData), 3000)
    },
    sendNotes () {
      if (this.selectedLeadNotes && this.selectedLeadNotes.length > 0) {
        this.$store.dispatch('sendNotesFromContact', {projectId: this.projectId, notes: this.selectedLeadNotes})
      }
    },
    loadConversionWindow () {
      this.projectName = this.selectedLead.opportunities.job_name ? this.selectedLead.opportunities.job_name + ' (' + this.selectedLead.company_name + ')' : this.selectedLead.company_name ? this.selectedLead.company_name + ' - ' + this.selectedLead.opportunities.address : this.selectedLead.last_name + ' - ' + this.selectedLead.opportunities.city
      this.showConversionWindow = true
    },
    statusChange (status) {
      const oldStatus = this.selectedLead.status
      const leadIndex = this.leadsList.findIndex(i => i.id === this.selectedLead.id)
      this.leadsList[leadIndex].opportunities.status = status
      this.selectedLead.allOpps[this.selectedLead.opportunities.index].status = status
      let payload = {contactId: this.selectedLead.id, contactName: this.selectedLead.first_name + ' ' + this.selectedLead.last_name, update: {opportunities: this.selectedLead.allOpps}, log: {changedFrom: oldStatus, changedTo: status}, logMessage: 'changed the status to'}
      if (status === 'Closed - Not Won') {
        this.selectedLead.allOpps[this.selectedLead.opportunities.index].active = false
        this.leadsList.splice(leadIndex, 1)
        // Check to See If Any Other Active Opportunties - If not set ifOppsPhase = false
        let activeOpps = []
        this.selectedLead.allOpps.forEach(opp => {
          if (opp.active) {
            activeOpps.push(opp)
          }
        })
        if (activeOpps.length > 0) {
          payload = {...payload, update: {opportunities: this.selectedLead.allOpps, closed_date: new Date()}}
        } else {
          payload = {...payload, update: {ifOppsPhase: false, opportunities: this.selectedLead.allOpps, closed_date: new Date()}}
        }
      }
      if (status !== 'Closed - Not Won' && this.selectedLead.allOpps[this.selectedLead.opportunities.index].active === false) {
        this.selectedLead.allOpps[this.selectedLead.opportunities.index].active = true
        payload = {...payload, update: {ifOppsPhase: true, opportunities: this.selectedLead.allOpps, closed_date: new Date()}}
      }
      this.$store.dispatch('updateLead', payload)
    },
    deleteNote (note) {
      if (confirm('Are you sure you want to delete the note (' + note.note + ')?')) {
        const noteIndex = this.selectedLead.allOpps[this.selectedLead.opportunities.index].notes.findIndex(n => n.note === note.note)
        const leadIndex = this.leadsList.findIndex(i => i.id === this.selectedLead.id)
        this.selectedLead.allOpps[this.selectedLead.opportunities.index].notes[noteIndex].deleted = true
        const payload = {leadIndex: leadIndex, allOpps: this.selectedLead.allOpps, contactId: this.selectedLead.id, contactName: this.selectedLead.first_name + ' ' + this.selectedLead.last_name, action: 'deleted', noteChanged: note.note}
        this.$store.dispatch('updateContactNotes', payload)
      }
    },
    addNote () {
      const leadIndex = this.leadsList.findIndex(i => i.id === this.selectedLead.id)
      if (!this.leadsList[leadIndex].notes) {
        this.leadsList[leadIndex].notes = []
      }
      const createdNote = {created_by: this.$store.getters.user.id, created_date: new Date(), deleted: false, note: this.newNote, phase: 'Leads'}
      this.leadsList[leadIndex].notes.push(createdNote)
      this.leadsList[leadIndex].allOpps[this.selectedLead.opportunities.index].notes.push(createdNote)
      const payload = Object.assign([], this.leadsList[leadIndex].notes)
      this.$store.dispatch('updateContactNotes', {allOpps: this.leadsList[leadIndex].allOpps, contactId: this.selectedLead.id, contactName: this.selectedLead.first_name + ' ' + this.selectedLead.last_name, notes: payload, action: 'added', noteChanged: this.newNote, createdNote: createdNote, phase: 'Leads'})
      // const noteIndex = payload.findIndex(i => i.note === this.newNote)
      // this.leadsList[leadIndex].notes[noteIndex].created_date = {seconds: new Date().getTime()}
      this.showNoteForm = false
      this.newNote = null
    },
    statusColors (status) {
      if (status === 'On Hold') {
        return ['OnHold', 'white--text']
      } else if (status === 'Completed') {
        return ['Completed', 'white--text']
      } else if (status === 'New Lead') {
        return ['NotStarted', 'white--text']
      } else if (status === 'In Progress') {
        return ['Started', 'white--text']
      } else if (status === 'Closed - Not Won') {
        return ['error', 'white--text']
      }
    },
    statusBorders (status) {
      if (status === 'On Hold') {
        return this.$vuetify.theme.OnHold
      } else if (status === 'Completed') {
        return this.$vuetify.theme.Completed
      } else if (status === 'New Lead') {
        return this.$vuetify.theme.NotStarted
      } else if (status === 'In Progress') {
        return this.$vuetify.theme.Started
      } else if (status === 'Closed - Not Won') {
        return this.$vuetify.theme.error
      }
    },
    contactLinks (type, value) {
      // window.open('mailto: ' + value)
      if (type === 'email') {
        location.href = 'mailto: ' + value
      }
      if (type === 'phone') {
        location.href = 'tel:' + value
      }
      if (type === 'address') {
        window.open('https://www.google.com/maps?q=' + value)
      }
    },
    formatCurrency (value) {
      return '$' + (parseInt(value)).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    },
    formatPhoneNumber (value) {
      let s2 = ('' + value).replace(/\D/g, '')
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
      return (!m) ? null : '(' + m[1] + ')' + ' ' + m[2] + '-' + m[3]
    }
  },
  components: {
    CustomerLead,
    CreateContact,
    Avatar
  }
}
</script>

<style scoped>
.pageContainer {
  display: flex;
  overflow: hidden;
  height: 100vh;
  position: relative;
  backface-visibility: hidden;
  will-change: overflow;
}
div.scroll {
  overflow: auto;
  height: auto;
  padding: .5rem;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
}
body {
    overflow-x: hidden;
}
h2 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 0 20px;
}
h2 span {
  background: #fff;
  padding: 0 10px;
}
.outlineBox {
  /* max-width: 100px; */
  margin: 20px;
  padding: 20px;
  border: 2px solid rgb(128, 128, 128, 0.5);
  border-radius: 15px;
}
.conversionWindow {
  background-color: white;
  border-radius: 30px;
}
.contactText {
  font-size: 16px;
}
.v-btn {
  margin-right: 0;
  margin-left: 0;
}
.v-list {
  padding: 0 !important;
}
.avatar {
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/components/leads/LeadsView.vue